import React, {ReactElement} from "react";
import {Box, FormControl, MenuItem, Select, styled} from "@mui/material";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {connect} from "react-redux";
import {RootState} from "../../redux/store";

const Root = styled(Box)(({theme}) => ({
    width: 'fit-content',
}));

interface IProps {
    value: string;
    texts: string[];
    onSelect: (val: string) => void;
    languageTokens: ILanguageTokens;
}

function SimpleSelect(props: IProps): ReactElement {

    const {value, onSelect, texts} = props;
    return (
        <Root>
            <FormControl fullWidth size={"small"}>
                <Select
                    aria-label={'Select Language'}
                    id="select"
                    value={value}
                    onChange={(event) => onSelect(event.target.value.toString())}
                >
                    {
                        texts.map(text =>
                            <MenuItem
                                key={text}
                                value={text}
                                aria-labelledby={text}
                            >
                                {text}
                            </MenuItem>
                        )
                    }
                </Select>
            </FormControl>
        </Root>
    );

}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {};


export default connect(mapStateToProps, mapActionsToProps)(SimpleSelect);
